import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import Button from '../../../atoms/button';
import ModuleCategory from '../../../components/module_category';
import LoadingSpinner from '../../../atoms/loading';
import I10n from '../../../features/i10n';
import { getQuestions } from '../../question-management/ducks';
import { getRacks } from '../../get-racks/ducks';
import MsxIcons from "../../msx-icons";
import { getAppLocale } from "../../../utils/app-locale";
import ProductCategory from "../../../models/ProductCategory";
import FilterContent from "../../../components/question_list_filter_answer";
import FilterHead from "../../../components/question_list_filter_header";
import { PRIMARY_COLOR } from "../../../color-constants";
import { computeEligibleCategories } from "../../../utils/module-category";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 0;
  align-items: stretch;
`;

const SearchReferenceInput = styled.input`
  border-radius: 20px;
  height: 30px;
  width: 100%;
  max-width: none;
  padding: 5px;
  border: 1px solid #E6E6E6;
  color: #A4A4A4;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  color: #9FA0A4;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 800px) {
    min-height: auto;
  }
  ${props => props.fullScreenEnabled && `
    min-height: auto;
  `}
  border-top: 2px solid #cccccc;
`;

const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const DeviceSectionContent = styled.div`
  position: relative;
  flex: 1 1 0px;
  background-color: #F4F4F4;
  padding: 10px;
  overflow: auto;
  border-bottom: 2px solid #cccccc;
`;

const DeviceSection = styled.section`
  flex: 3 1 0px;
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
`;

const MobileQuestionManagement = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobileQuestionButton = styled.div`
  display: flex;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  padding-left: 5px;
  font-size: 14px;
  min-height: 32px;
`;

const ClearFilterButton = styled(MobileQuestionButton)`
  padding: 0px 10px;
`;

const MobileQuestionButtonLabel = styled.span`
  font-size: 14px;
  margin-left: 5px;
`;

const ArrowWrapper = styled.div`
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingMask = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;

const NavigationButtonSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const SearchBarTestWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background-color: #F4F4F4;
`;

const SearchHeader = styled.div`
  flex: 1 1 0px;
`;

const SearchBarWrapper = styled.div`
  flex: 1 1 0px;
  display: flex;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 99%;
  height: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: -8px;
  position: relative;
`;

const SearchBarIcon = styled.div`
    position: relative;
    left: 35px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

class ModalSetRack extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      search: '',
      moduleSelected: null,
      moduleSelectedMaxAmount: 0,
      selectedDeviceAmount: 1,
      categories: [],
      remainingCriteria: null,
      sharedOptions: null,
      baseCriteria: null,
      questionsWithAnswers: {},
      openMobileQuestionsCallback: null,
      isFilterOpen: window.innerWidth > 800
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.getAggregatedQuestions(this.props.questionType).then((success) => {
      this.refreshModules({}, true);
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  removeSelectedModuleIfNotInResult(references) {
    const referencesId = references.map((e) => { return e.id; });
    if (this.state.moduleSelected) {
      if (referencesId.indexOf(this.state.moduleSelected.id) === -1) {
        this.updateStateIfMounted({ moduleSelected: null });
      }
    }
  }

  filterCategories(categories) {
    const _categories = (categories || []).map(cat => {
      let categoryData = (cat || {});
      if (categoryData.hasOwnProperty('rawData')) {
        categoryData = categoryData.rawData;
      }
      return new ProductCategory(categoryData);
    });
    return _categories.filter(c => (c?.references || []).length);
  }

  refreshModules(questionsWithAnswers, initialCall = false) {
    const criteria = this.buildCriteriaPayload(questionsWithAnswers);
    this.props.getRacks(this.props.configuration, criteria, this.props.islandConfiguration, this.props.isIsland, this.props.ruggedization)
      .then((payload) => {
        const allReferences = [];
        for (let category of payload?.categories) {
          allReferences.push(...category.references);
        }

        if (initialCall) {
          this.updateStateIfMounted({ categories: this.filterCategories(payload?.categories), remainingCriteria: payload.remainingCriteria, baseCriteria: payload.remainingCriteria, sharedOptions: payload.sharedCriteria });

        } else {
          this.updateStateIfMounted({ categories: this.filterCategories(payload?.categories), remainingCriteria: payload.remainingCriteria, sharedOptions: payload.sharedCriteria });
        }
        this.removeSelectedModuleIfNotInResult(allReferences);

      }).catch((error) => { });
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      this.setState(objectToAffect);
    }
  }

  getQuestionMap() {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  buildCriteriaPayload(questionsWithAnswers) {
    const payload = {};
    const questionMap = this.getQuestionMap();
    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      payload[questionMap[key].criteria] = answer;
    }
    return payload;
  }

  get numberQuestionsAnswered() {
    return Object.keys(this.state.questionsWithAnswers).length;
  }

  get haveQuestionsAnswered() {
    return !!Object.keys(this.state.questionsWithAnswers).length;
  }

  onAnswerChanged = (questionsWithAnswers, initialCall = false) => {
    this.updateStateIfMounted({ questionsWithAnswers: questionsWithAnswers });
    this.refreshModules(questionsWithAnswers, initialCall);
  }

  resetQuestionAnswers() {
    this.onAnswerChanged({});
  }

  get hasSelection() {
    return this.state.moduleSelected !== null;
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.currentTarget.value });
  }

  renderRacks = () => {
    const appLocale = getAppLocale();
    const categories = this.state.categories || [];
    const eligibleCategories = computeEligibleCategories(categories, this.state.search, this.props.configuration.showPrecommercializedProducts) || [];

    // Do not show the indications if the modules are loading.
    if (!this.props.racks.isLoading && !this.props.questions.isLoading) {
      if (!categories.length && !this.haveQuestionsAnswered) {
        return <p>{I10n.getAndReplace(`modal.set_rack.suggest.empty`, appLocale)}</p>;
      }
      if (!eligibleCategories.length) {
        return <p>{I10n.get(`modal.set_rack.suggest.no-match`)}</p>;
      }
    }

    return eligibleCategories.map(category => {
      return <ModuleCategory
        title={I10n.getOrDefault(`category.${category.translationKey}.name`, category.label, 'data')}
        label={category.label}
        description={I10n.getOrDefault(`category.${category.translationKey}.description`, category.description, 'data')}
        detailedDescription={category.detailedDescription}
        image={category.imageURL}
        references={category.references}
        setSelectedDevice={(mod) => {
          this.setState({ moduleSelected: mod, moduleSelectedMaxAmount: 1, selectedDeviceAmount: 1 });
        }}
        selectedDevice={this.state.moduleSelected}
        key={category.label}
        withCount={true}
        onOpenStateChange={(isOpen, ref) => {
          this.forceUpdate();
          if (isOpen) {
            setTimeout(() => {
              this.scrollComponent.view.scrollTop = ref.current.offsetTop;
            }, 0);
          }
        }}
        // Do not use force forceOpen to open if still loading
        forceOpen={!this.props.questions.isLoading && (this.haveQuestionsAnswered || eligibleCategories.length === 1)}
      ></ModuleCategory>
    });
  }

  toggleMobileFilter = (status) => {
    this.updateStateIfMounted({ mobileFilterOpened: status });
  }

  renderMobileQuestionButton = () => {
    const label = this.haveQuestionsAnswered ? `${I10n.get('screen.head_device_selector_screen.plc.filters')} (${this.numberQuestionsAnswered})` : I10n.get('screen.head_device_selector_screen.plc.filters');
    return <MobileQuestionButton onClick={() => {
      this.toggleMobileFilter(true);
    }}>
      <MsxIcons name="filter"></MsxIcons>
      <MobileQuestionButtonLabel>{label}</MobileQuestionButtonLabel>
      <ArrowWrapper>
        <MsxIcons name="right-arrow" size="nano"></MsxIcons>
      </ArrowWrapper>
    </MobileQuestionButton>;
  }


  render = () => {
    const {aggregatedQuestions = [] } = this.props.questions || {};
    const hasQuestions = aggregatedQuestions.length > 0;
    return (
      <Container>
        <Header id="modal-set-rack-header">
          <TitleWrapper>
            <Title>{I10n.get('modal.set_rack.title')}</Title>
            {this.props.isIsland && !this.props.disableCrossModal &&
              <CloseIcon onClick={(e) => {
                e.preventDefault();
                this.props.closeModal();
              }}>
                <MsxIcons name="close"></MsxIcons>
              </CloseIcon>
            }
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Body>
          <ContentWrapper id='modal-set-rack-contentWrapper'>
              <SearchBarTestWrapper id='modal-set-rack-TEST2'>
                <SearchBarWrapper>
                  <SearchHeader id='modal-set-rack-TEST3'>
                    <SearchBar id='modal-set-rack-TEST4'>
                      <SearchBarIcon>
                        <MsxIcons name="search" size="small"></MsxIcons>
                      </SearchBarIcon>
                      <SearchReferenceInput
                        id="head-device-selector-screen-search-input"
                        type="search"
                        placeholder={I10n.get(`modal.set_rack.search.placeholder`)}
                        value={this.state.search}
                        onChange={this.handleSearchChange}
                        style={{ paddingLeft: '50px' }}
                        color='#E6E6E6'
                      />
                    </SearchBar>
                  </SearchHeader>
                </SearchBarWrapper>
              </SearchBarTestWrapper>
          </ContentWrapper>
          <Content id="3">
            {hasQuestions &&
              <React.Fragment>
                <FilterHead
                  isLoading={this.props.questions.isLoading}
                  isFilterOpen={this.state.isFilterOpen}
                  toggleFilter={this.toggleFilter}
                  numChecked={this.state.numChecked}
                />
                <FilterContent
                  aggregatedQuestions={this.props.questions.aggregatedQuestions}
                  isLoading={this.props.questions.isLoading}
                  onAnswerChanged={this.onAnswerChanged}
                  questionsWithAnswers={this.state.questionsWithAnswers}
                  questionMap={this.getQuestionMap()}
                  resultsLoading={this.props.compatibleModules.isLoading || this.props.compatibleIslandModules.isLoading}
                  remainingOptions={this.state.remainingCriteria}
                  sharedOptions={this.state.sharedOptions}
                  resetQuestionAnswers={this.resetQuestionAnswers}
                  mobileFilterOpened={this.state.mobileFilterOpened}
                  toggleMobileFilter={this.toggleMobileFilter}
                />
              </React.Fragment>
            }
            <DeviceSection>
              <MobileQuestionManagement>
                {!this.props.questions.isLoading && this.props.questions?.aggregatedQuestions?.length > 0 && this.renderMobileQuestionButton()}
                {this.haveQuestionsAnswered && (
                  <ClearFilterButton onClick={(e) => {
                    e.preventDefault();
                    this.resetQuestionAnswers();
                  }}>
                    {I10n.get(`screen.head_device_selector_screen.plc.answers_reset_hover`)}
                  </ClearFilterButton>
                )}
              </MobileQuestionManagement>
              <DeviceSectionContent>
                {(this.props.questions.isLoading ||this.props.racks.isLoading) &&
                  <LoadingMask>
                    <LoadingSpinner></LoadingSpinner>
                  </LoadingMask>
                }
                <Scrollbars ref={c => { this.scrollComponent = c }}>
                  {this.renderRacks()}
                </Scrollbars>
              </DeviceSectionContent>
            </DeviceSection>
          </Content>
          <NavigationButtonSection>
            <Button importance="emphasized" primary disabled={!this.hasSelection}
              onClick={event => {
                this.props.setRack(this.state.moduleSelected.id);
                this.props.closeModal();
              }}
            >
              {I10n.get('modal.set_rack.next')}
            </Button>
          </NavigationButtonSection>
        </Body>
      </Container>
    );
  }
  }

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    getAggregatedQuestions: (questionType) => dispatch(getQuestions(questionType)),
    getRacks: (config, criteria, islandConfiguration, isIsland, ruggedization) =>
      dispatch(getRacks(config, criteria, islandConfiguration, isIsland, ruggedization)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalSetRack);
